import { useContext } from 'react';
import { matchSorter } from 'match-sorter';
import AppContext from '../../../common/containers/AppContext';

export default function useFindCustomers(searchText) {
    const { customers } = useContext(AppContext);

    const filteredCustomers = customers
        ? matchSorter(customers, searchText, { keys: ['label'] })
        : [];
    return [filteredCustomers, false, false];
}
